module.exports = __webpack_public_path__ + "img/无线路由器.749e6396.png";